import { Box } from '@mui/material';
import { getStatusLabel } from '../../Utils/DecideStatus';
import { getCellStyle } from '../../Utils/DecideColor';
import { InputGroup } from 'reactstrap';
const TableColumns = (status, handleQuantityChange, quantities, isAcknowledged, id) => {
    const columns = [
        {
            accessorFn: (row) => {
                return row.subscriptionID !== "" ? row.subscriptionID : id
            },
            header: 'Subscription ID'
        },
        // { accessorKey: 'serviceName', header: 'Service' },
        { accessorKey: 'offerName', header: 'Offer' },
        {
            accessorFn: (row) => {
                const start = row.subscriptionStartsOn || row.validityFrom;
                const end = row.subscriptionEndsOn || row.validityTo;
                return `${start ? start : 'N/A'} - ${end ? end : 'N/A'}`;
            },
            header: 'Duration',
        },
        {
            header: 'Quantity',
            Cell: ({ row }) => {
                const subscriptionID = row.original.subscriptionID; // Get subscription ID
                const quantity = row?.original?.quantity || 1; // Default to 1 if not set
                return (
                    <div className="quantity-control d-flex align-items-center">
                        <InputGroup className="border border-1 rounded-1 d-flex justify-content-between align-items-center">
                            <input
                                type="number"
                                className="quantity-input mx-2 border-0 rv-label-muted bg-transparent"
                                value={quantity}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === '') {
                                        handleQuantityChange(subscriptionID, ''); // Handle empty input
                                    } else {
                                        handleQuantityChange(subscriptionID, Math.max(1, Number(value))); // Update quantity
                                    }
                                }}
                                min={1}
                                disabled={isAcknowledged}

                            />
                            <div className="text-end flex-grow-1">
                                <button
                                    className="border-0 bg-transparent"
                                    type="button"
                                    disabled={isAcknowledged}
                                    onClick={() => handleQuantityChange(subscriptionID, Math.max(1, quantity - 1))}
                                >
                                    <span className="rv-label-muted fw-bold">
                                        -
                                    </span>
                                </button>
                                <span className="rv-label-muted ">
                                    |
                                </span>
                                <button
                                    className="border-0 bg-transparent fw-bold"
                                    type="button"
                                    disabled={isAcknowledged}
                                    onClick={() => handleQuantityChange(subscriptionID, quantity + 1)
                                    }
                                >
                                    <span className="rv-label-muted ">
                                        +
                                    </span>
                                </button>
                            </div>
                        </InputGroup>
                    </div>
                );
            },
        },
        // {
        //     accessorFn: () => `${status}`,
        //     header: 'Status',
        //     Cell: ({ cell }) => (
        //         <Box sx={(theme) => (cell.getValue() ? {
        //             ...getCellStyle(cell.getValue(), "CreateOrder"),
        //         } : {})}>
        //             {getStatusLabel(status)}
        //         </Box>
        //     ),
        // },
        { accessorKey: 'unitPrice', header: 'Unit Price' },
        { accessorKey: 'subTotal', header: 'Subtotal' },

    ];

    const viewColumns = [
        { accessorKey: 'subscriptionID', header: 'Subscription ID' },
        { accessorKey: 'serviceName', header: 'Service' },
        { accessorKey: 'offerName', header: 'Offer' },
        { accessorKey: 'duration', header: 'Duration' },
        {
            accessorKey: 'status',
            header: 'Status',
            Cell: ({ cell }) => (
                <Box sx={(theme) => (cell.getValue() ? {
                    ...getCellStyle(cell.getValue(), "ViewOrder"),
                } : {})}>
                    {getStatusLabel(cell.getValue())}
                </Box>
            ),
        },
        { accessorKey: 'unitPrice', header: 'Unit Price' },
        { accessorKey: 'subTotal', header: 'Subtotal' },
    ];

    return { columns, viewColumns };
};

export default TableColumns;
